var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 24,
    viewBox: "0 0 2158 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1187.26 246.007H1085.3L1024.52 93.6005H930.889L999.516 258.258C1018.63 303.833 1059.32 320.985 1124.52 320.985C1141.67 320.985 1154.42 320.005 1161.77 316.574V327.355C1146.58 350.388 1123.05 359.209 1077.95 359.209H1033.83V432.227H1090.2C1176.48 432.227 1222.56 386.162 1259.81 290.111L1337.26 93.6005H1246.09L1187.26 246.007Z",
    fill: "#FF7377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1622.05 210.722H1444.11V94.0895H1359.31V182.299C1359.31 255.807 1421.56 291.09 1502.94 291.09C1546.07 291.09 1590.19 285.7 1621.56 273.939V359.208H1706.37V94.0895H1621.56V210.722H1622.05Z",
    fill: "#FF7377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2101.01 91.1505C2067.18 91.1505 2055.42 98.0112 2024.05 127.414L1877.48 265.119H1865.22V93.6008H1780.42V329.806C1780.42 356.269 1802.48 361.659 1836.79 361.659C1870.61 361.659 1886.3 354.799 1917.67 325.396L2060.32 191.611H2072.58V358.719H2157.38V123.004C2157.38 96.5411 2134.83 91.1505 2101.01 91.1505Z",
    fill: "#FF7377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.541 142.115L242.169 0H212.267L205.894 142.115L190.698 147.506L101.972 36.2639L77.4619 54.3958L155.404 172.008C179.423 207.782 250.502 187.2 248.541 142.115Z",
    fill: "#FF7377"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07 225.913L453.914 175.928L445.09 147.505L308.815 185.729L298.521 172.498L376.463 52.9249L352.933 36.2631L264.207 147.015C238.226 179.848 277.933 242.575 321.07 225.913Z",
    fill: "#FF7377"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.885 296.482L76.9629 414.094L101.473 432.226L190.199 320.984L205.885 326.375L212.258 468H242.16L248.532 326.375C250.493 280.8 180.885 258.748 155.885 296.482Z",
    fill: "#FF7377"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.079 185.73L8.82358 147.506L0 175.929L133.334 225.914L132.844 242.576L0 291.581L8.82358 320.004L146.079 282.27C190.197 270.999 189.217 197.981 146.079 185.73Z",
    fill: "#FF7377"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.212 321.476L352.938 431.738L377.448 413.606L298.526 295.994L308.82 282.762L445.586 320.496L454.409 292.073L321.075 242.578C277.938 226.406 235.781 285.213 264.212 321.476Z",
    fill: "#FF7377"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M751.959 87.2282C702.448 87.2282 671.076 92.6188 656.86 119.572L530.389 359.207H628.428L725.488 169.557H778.429L875.489 358.717H973.038L848.528 121.042C833.332 92.1287 801.469 87.2282 751.959 87.2282Z",
    fill: "#FF7377"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.53973e61815432356e203945a005be7a.svg";
export { ForwardRef as ReactComponent };